import { BookmarkConfiguration } from './BookmarkConfiguration';
import { createPlaybackSessionBookmarkerImpl } from './internal/PlaybackSessionBookmarkerImpl';
import { createBookmarkServiceImpl } from './bookmarkService/internal/BookmarkServiceImpl';
import { BookmarkService } from './BookmarkService';
import { PlaybackSessionBookmarker } from './PlaybackSessionBookmarker';
import { BookmarkRecord } from './bookmarkService/modal/BookmarkRecord';
import { BookmarkCount, SortBy, SortOrder } from './bookmarkService/internal/BookmarkResponse';
import { Mode } from './bookmarkService/internal/BookmarkRequest';
import { EpisodeDetails } from '@quickplay/player-interface';

const version = '__buildVersion__';

export {
  BookmarkConfiguration,
  createPlaybackSessionBookmarkerImpl as createPlaybackSessionBookmarker,
  createBookmarkServiceImpl as createBookmarkService,
  BookmarkService,
  BookmarkCount,
  PlaybackSessionBookmarker,
  version,
  BookmarkRecord,
  SortBy,
  SortOrder,
  Mode,
  EpisodeDetails,
};
